<template>
  <div class="event-player smooth-shadow">
    <div class="progress-bar">
      <div class="bar" :style="{ width: `${progress}%` }"></div>
    </div>
    <div class="control-area">
      <i class="material-icons player-control-button" @click="rewind"
        >fast_rewind</i
      >
      <i class="material-icons play-pause-button" @click="togglePlay">{{
        play ? "pause" : "play_arrow"
      }}</i>
      <i class="material-icons player-control-button" @click="forward"
        >fast_forward</i
      >
      <expand />
      <button class="speed-button" @click="changeSpeed">
        Playback Speed
        <span>{{ speed }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    play: Boolean,
    speed: String,
    progress: Number,
  },
  methods: {
    changeSpeed() {
      this.$emit("changeSpeed");
    },
    togglePlay() {
      this.$emit("toggle");
    },
    rewind() {
      this.isPlaying = false;
      this.$emit("rewind");
    },
    forward() {
      this.isPlaying = false;
      this.$emit("forward");
    },
  },
};
</script>

<style lang="scss" scoped>
.event-player {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  bottom: 0px;
  border-radius: 0 0 5px 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  border: 1px solid var(--border-color);
  z-index: 999;

  .progress-bar {
    height: 3px;
    width: 100%;
    display: flex;
    background: var(--color-default-background);

    .bar {
      display: flex;
      height: 100%;
      background: var(--color-accent);
      border-radius: 0 5px 5px 0;
    }
  }

  .control-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px;

    .player-control-button {
      background: var(--color-secondary-light);
      padding: 10px;
      margin: 5px;
      border-radius: 50%;
      transition: 0.3s all ease-in-out;

      &:hover {
        opacity: 0.7;
        cursor: pointer;
        color: var(--color-primary);
      }

      &:active {
        transform: scale(0.9);
      }
    }

    .play-pause-button {
      padding: 10px;
      background: var(--color-primary);
      color: var(--color-secondary);
      border-radius: 50%;
      font-size: 34px;
      transition: 0.3s all ease-in-out;
      outline: none;

      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }

      &:active {
        transform: scale(0.9);
      }
    }

    .speed-button {
      background: transparent;
      border: 0;
      padding: 10px 15px;
      color: var(--font-color);
      border-radius: 5px;
      transition: 0.3s all ease-in-out;
      outline: none;

      span {
        color: var(--color-primary);
      }

      &:hover {
        background: var(--color-secondary-light);
        cursor: pointer;
      }

      &:active {
        opacity: 0.7;
        transform: scale(0.97);
      }
    }
  }
}
</style>
